import { newDate } from "helpers/dateTools";

export const GET_LICENSES_VOLUMETRIC_INV = 'GET_LICENSES_VOLUMETRIC_INV';
export const CHANGE_CRE_LICENSE_VOLUMETRIC_INV = 'CHANGE_CRE_LICENSE_VOLUMETRIC_INV';
export const GET_VOLUMETRIC_INV = 'GET_VOLUMETRIC_INV';
export const SELECT_VOLUMETRIC_INV = 'SELECT_VOLUMETRIC_INV';
export const CLEAR_VOLUMETRIC_INV = 'CLEAR_VOLUMETRIC_INV';
export const VOLUMETRIC_INV_INPUTS_FILTERS = 'VOLUMETRIC_INV_INPUTS_FILTERS';


const INITIAL_STATE = {

    // filters
    creLicenseSelected: null,
    startDate: newDate(),
    endDate: newDate(),

    //info
    creLicenses: [],
    volumetricsInv: [],
    volumetricSelected: {},

}

export const volumetricsInvReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        // filter
        case VOLUMETRIC_INV_INPUTS_FILTERS:
            return {
                ...state,
                [payload.key]: payload.value
            };
        case CHANGE_CRE_LICENSE_VOLUMETRIC_INV:
            return {
                ...state,
                creLicenseSelected: payload
            };
        //request
        case GET_LICENSES_VOLUMETRIC_INV:
            return {
                ...state,
                creLicenses: payload
            }
        case GET_VOLUMETRIC_INV:
            return {
                ...state,
                volumetricsInv: payload
            }
        case SELECT_VOLUMETRIC_INV:
            return {
                ...state,
                volumetricSelected: payload
            }
        case CLEAR_VOLUMETRIC_INV:
            return {
                ...state,
                ...INITIAL_STATE,
                creLicenses: state.creLicenses,
            };
        default:
            return state;
    }
}